import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  header: {
    position: 'relative',
    backgroundColor: theme.palette.neutral.lightest,
  },
  closeButton: {
    position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(2),
    display: 'block',
    backgroundColor: theme.palette.neutral.lightest,
  },
  closeIcon: {
    display:'flex',
    padding: theme.spacing(0.5),
    marginLeft: 'auto',
    cursor:'pointer'
  },
  clock: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    '& .pie': {
      animationName: '$strokeAnimate',
      animationTimingFunction: 'linear',
      animationFillMode: 'forwards',
      animationDuration: props => `${props}ms`,
    },
  },
  counter: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
    ...theme.typography.h4,
    color: theme.palette.neutral.dark,
    fontSize: 21,
  },
  alert: {
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(2),
    },
  },
  infoContainerMobile: {
    padding: theme.spacing(4, 2),
    backgroundColor: theme.palette.neutral.white,
  },
  titleMobile: {
    marginBottom: theme.spacing(2),
  },
  dialogIconAlert: {
    '& .MuiPaper-root': {
      flexDirection: 'row',
      maxWidth: 560,
    },
  },
  dialogIconAlertBoxIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 82,
    backgroundColor: theme.palette.warning.light,
    color: theme.palette.warning.darkest,
  },
  '@keyframes strokeAnimate': {
    to: {
      strokeDashoffset: '0px',
    },
  },
  emptyContent: {
    '& .MuiDialogActions-root': {
      paddingTop: 0,
    },
  },
  wide: {
    '& .MuiDialog-paper.MuiPaper-root': {
      width: 1155,
      maxWidth: 'none',
    },

    '& .css-1klmhec-MuiDialogContent-root': {
      padding:theme.spacing(4, 4, 0, 4)
    }
  },
}))

export default useStyles
